import angular from 'angular';
import _ from 'lodash';
import Logger from '../../../../../shared/logger';

export const JobListingLineChart = (StatsService, $q, $filter) => {
    let dataSourceNew = [];

    const updateDataSource = function (startDay, jobTitle, text, statusIndex) {
        dataSourceNew.push({
            day: startDay,
            dayIndex: startDay,
            statusIndex,
        });
        dataSourceNew[dataSourceNew.length - 1][jobTitle] = text;
    };

    let dataEnteredByPositionId = [];

    const getDataEnteredByPositionId = function (id) {
        const obj = _.find(dataEnteredByPositionId, { positionId: id });
        if (obj) {
            return obj;
        }
        return null;
    };

    const setJobListingData = function (data) {
        dataEnteredByPositionId = _.sortBy(data, 'dayIndex');
    };
    const getJobListingData = function () {
        return dataEnteredByPositionId;
    };

    const getJobListingLineChart = async function () {
        try {
            const { result: businessKpi } = await StatsService.getBusinessKpi();
            const newText = $filter('translate')('NEW_JOB_TIMELINE');
            const jobEnteredText = $filter('translate')('JOB_ENTERED_TIMELINE');
            const sendForFeedbackText = $filter('translate')('SEND_FOR_FEEDBACK_TIMELINE');
            const feedbackReceivedText = $filter('translate')('FEEDBACK_RECEIVED_TIMELINE');
            const firstSubmissionText = $filter('translate')('FIRST_SUBMISSION_TIMELINE');
            const abandonedText = $filter('translate')('ABANDONED_TIMELINE');
            const timeLineKPI = _.find(businessKpi, 'timelineView');
            let finishedTarget = 18;

            if (timeLineKPI) {
                updateDataSource(timeLineKPI.timelineView.newJob, 'exp', newText, 1);
                updateDataSource(timeLineKPI.timelineView.jobEntered, 'exp', jobEnteredText, 2);
                updateDataSource(timeLineKPI.timelineView.sendForFeedback, 'exp', sendForFeedbackText, 3);
                updateDataSource(timeLineKPI.timelineView.feedbackReceived, 'exp', feedbackReceivedText, 4);
                updateDataSource(timeLineKPI.timelineView.firstSubmission, 'exp', firstSubmissionText, 5);
                updateDataSource(timeLineKPI.timelineView.finished, 'exp', abandonedText, 6);
                finishedTarget = timeLineKPI.timelineView.finished;
            } else {
                updateDataSource(1, 'exp', newText, 1);
                updateDataSource(2, 'exp', jobEnteredText, 2);
                updateDataSource(3, 'exp', sendForFeedbackText, 3);
                updateDataSource(4, 'exp', feedbackReceivedText, 4);
                updateDataSource(9, 'exp', firstSubmissionText, 5);
                updateDataSource(18, 'exp', abandonedText, 6);
            }

            const options = {
                dataSource: dataSourceNew,
                commonSeriesSettings: {
                    argumentField: 'day',
                    point: {
                        symbol: 'square',
                    },
                },
                argumentAxis: {
                    discreteAxisDivisionMode: 'crossLabels',
                    grid: {
                        visible: false,
                    },
                    label: {
                        // Distance between argumentAxis (x) and the labels below it
                        indentFromAxis: 0,

                        customizeText(e) {
                            return e.valueText;
                        },
                        customizeHint(e) {
                            return e.valueText;
                        },
                        visible: true,
                        font: {
                            color: '#000000',
                            family: 'Source Sans Pro',
                            weight: 400,
                            size: 12,
                        },
                    },
                },
                valueAxis: {
                    discreteAxisDivisionMode: 'crossLabels',
                    label: {
                        visible: true, // Show text labels
                        font: {
                            color: '#000000',
                            family: 'Source Sans Pro',
                            weight: 400,
                            size: 12,
                        },
                    },
                    // Set order of displayed valueAxis strings
                    valueType: 'string',
                    categories: [
                        newText, jobEnteredText, sendForFeedbackText, feedbackReceivedText, firstSubmissionText, abandonedText,
                    ],
                },
                legend: {
                    verticalAlignment: 'bottom',
                    horizontalAlignment: 'center',
                    itemTextPosition: 'right',
                    margin: {
                        top: 22,
                        bottom: 13,
                    },
                },
                tooltip: {
                    enabled: true,
                    customizeTooltip(arg) {
                        if (arg.seriesName === '') {
                            return null;
                        }
                        return {
                            text: `${arg.seriesName}<br/>${arg.argumentText !== '' ? (`${arg.valueText}: ${arg.argumentText} days`) : ''}`,
                        };
                    },
                },
                adaptiveLayout: {
                    width: 1,
                    height: 1
                },
            };

            return {
                options,
                finishedTarget,
            };
        } catch (error) {
            Logger.error(error)
        }
    };
    return {
        getJobListingLineChart,
        getDataEnteredByPositionId,
        getJobListingData,
        setJobListingData,
    };
};

angular
    .module('TALENYA-FE')
    .factory('JobListingLineChart', JobListingLineChart);

